import React from 'react';

export const modificationToAccessOrSiteMessages = {
  value: 'Modification to Access or Site',
  list: [
    {
      value: (
        <>
          Glints reserves the right at any time and from time to time to modify,
          change, suspend, discontinue or restrict (a) users’ access to, either
          temporarily or permanently, the Site (or any part thereof); or (b) the
          whole or any portion of this Site (and the services provided therein),
          with or without notice. Glints shall not be liable to users or to any
          third party for any such modification, change, suspension,
          discontinuation or restriction.
        </>
      ),
    },
  ],
};
